document.addEventListener("DOMContentLoaded", function () {
  console.log("Weather script started");

  // Core function
  function currentcountry(response) {
    console.log("Geo response:", response);

    let country_name = response && response.country_name ? response.country_name : "Netherlands";
    let city = response && response.city ? response.city : "Amsterdam";
    let country_code2 = response && response.country_code2 ? response.country_code2 : "NL";

    const locationLabel = document.querySelector(".currenct_countrycls");
    if (locationLabel) locationLabel.textContent = city + ", " + country_name;

    const finalQuery = `${city},${country_code2}`;
    const weatherURL = `https://api.openweathermap.org/data/2.5/forecast/daily?q=${encodeURIComponent(finalQuery)}&appid=178ab4218cf64617521c609fcd1c966a&units=metric&cnt=4`;

    console.log("Fetching weather for:", finalQuery);

    fetch(weatherURL)
      .then(r => r.json())
      .then(data => {
        if (!data || !data.list) {
          console.warn("Weather data missing — fallback to Amsterdam");
          return currentcountry({ country_name: "Netherlands", city: "Amsterdam", country_code2: "NL" });
        }

        const container = document.querySelector(".forcast_table");
        const thermoSVG = document.querySelector(".cls_clear") ? "" : "";
        const bgWrapper = document.querySelector(".weather-section__bg");
        container.innerHTML = "";

        let htmlForecast = "";
        for (let i = 0; i < data.list.length; i++) {
          const dayData = new Date();
          dayData.setDate(dayData.getDate() + i);
          const dayName = dayData.toLocaleDateString("en-GB", { weekday: "short" });
          const dayLabel = dayData.toLocaleDateString("en-GB", { month: "short", day: "numeric" });

          const temps = data.list[i].temp;
          const tempNow = temps.day ?? temps.morn ?? 0;
          const condition = data.list[i].weather[0].main || "Clear";
          const condKey = condition.toLowerCase();

          const iconMap = {
            drizzle: ".cls_drizzle",
            thunderstorm: ".cls_thunderstorm",
            rain: ".cls_rain",
            snow: ".cls_snow",
            atmosphere: ".cls_atmosphere",
            clear: ".cls_clear",
            clouds: ".cls_clouds"
          };
          const iconHTML = document.querySelector(iconMap[condKey] || ".cls_clear")?.innerHTML || "";

          if (i === 0) {
            document.querySelectorAll(".wathr_maintitle span").forEach(s => (s.style.display = "none"));
            const title = document.querySelector("." + condKey + "_title");
            if (title) title.style.display = "inline";
            const capIcon = document.querySelector(".cap_w_icon");
            if (capIcon) capIcon.innerHTML = iconHTML;
            const tempEl = document.querySelector(".current-temp-value");
            if (tempEl) tempEl.textContent = Math.round(tempNow) + "°C";

            const bgMap = {
              drizzle: "weather-bg--drizzle",
              thunderstorm: "weather-bg--thunderstorm",
              rain: "weather-bg--rain",
              snow: "weather-bg--snow",
              atmosphere: "weather-bg--atmosphere",
              clear: "weather-bg--clear",
              clouds: "weather-bg--clouds"
            };
            bgWrapper.className = "weather-section__bg " + (bgMap[condKey] || "weather-bg--default");
            // show correct background image
document.querySelectorAll('.weather-bg').forEach(img => img.classList.remove('show'));
const bgImage = document.querySelector('.' + condKey + '_image');
if (bgImage) bgImage.classList.add('show');

          }

          htmlForecast += `
            <li class="weather-forecast__item">
              <div class="forecast-day"><div>${dayName}</div><div>${dayLabel}</div></div>
              <div class="forecast-icon">${iconHTML}</div>
              <div class="forecast-temp"><span>${Math.round(tempNow)}°C</span></div>
            </li>`;
        }

        container.innerHTML = htmlForecast;
      })
      .catch(err => {
        console.error("Weather fetch failed:", err);
      });
  }

  // --- Run ---
  try {
    console.log("Running geolocation...");
    if (typeof _ipgeolocation === "object" && _ipgeolocation.getGeolocation) {
      _ipgeolocation.getGeolocation(currentcountry, "YOUR_VALID_API_KEY_HERE");
    } else {
      console.warn("Geo API not loaded → fallback to Amsterdam");
      currentcountry({ country_name: "Netherlands", city: "Amsterdam", country_code2: "NL" });
    }
  } catch (err) {
    console.error("Weather init error:", err);
    currentcountry({ country_name: "Netherlands", city: "Amsterdam", country_code2: "NL" });
  }
});
